import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import env from '../../../configs/envConfig';

const PAGE_TITLES = {
  '/': 'Resume Parser',
  '/interview-questions': 'Interview Questions Generator',
};

export default function AppNavBar() {
  const { pathname } = useLocation();
  const pageTitle = PAGE_TITLES[pathname] ?? 'Resume Parser';

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);
  const reportEmail = env.REACT_APP_RESUME_PARSER_SUPPORT_EMAIL;
  const reportSubject = env.REACT_APP_RESUME_PARSER_REPORT_SUBJECT || 'Resume Parser - Bug Report';
  const reportBodyTemplate = env.REACT_APP_RESUME_PARSER_REPORT_BODY;

  const handleReportClick = () => {
    console.log('Report button clicked!');
    console.log('reportEmail:', reportEmail);
    console.log('reportSubject:', reportSubject);
    console.log('reportBodyTemplate:', reportBodyTemplate);

    // Check if required env vars are set
    if (!reportEmail || !reportBodyTemplate) {
      console.error('Report email configuration is missing');
      alert('Report feature is not configured. Please contact your administrator.');
      return;
    }

    try {
      // Replace \n with actual newlines and inject dynamic values
      const reportBody = reportBodyTemplate
        .replace(/\\n/g, '\n')
        .replace('{BROWSER}', navigator.userAgent || 'Unknown')
        .replace('{DATETIME}', new Date().toLocaleString());

      const mailtoLink = `mailto:${reportEmail}?subject=${encodeURIComponent(reportSubject)}&body=${encodeURIComponent(reportBody)}`;

      console.log('Generated mailto link:', mailtoLink);
      console.log('Attempting to open email client...');

      window.location.href = mailtoLink;

      console.log('Email client should have opened');
    } catch (error) {
      console.error('Failed to open email client:', error);
      alert('Failed to open email client. Please check your browser settings or email configuration.');
    }
  };

  return (
    <nav className="app-navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <span className="navbar-logo">📄</span>
          <span className="navbar-title">{pageTitle}</span>
        </div>
        <div className="navbar-actions">
          <button
            onClick={handleReportClick}
            className="report-button"
            title="Report a bug or issue"
          >
            Report an Issue ↗
          </button>
        </div>
      </div>
    </nav>
  );
}
